// TODO move file to utils
import { config } from "@/auth/config";

export const getNextIndex = (code: string, index: number): number => {
  switch (code.toLocaleLowerCase()) {
    case 'arrowup':
      return --index;
    case 'arrowdown':
      return ++index;
    default:
      return index;
  }
}

export const getTargetElement = (element: HTMLElement): HTMLElement => {
  if (element.tagName === 'DIV' && (Array.from(element.classList) || []).includes('button')) {
    return element.children?.[0] as HTMLElement || element;
  }
  if (element.tagName === 'DIV' && (Array.from(element.classList) || []).includes('ui-input')) {
    return Array.from(element.children).find(i => i.tagName === 'INPUT') as HTMLElement || element;
  }
  return element;
}

export const getIndexClass = () => {
  if (
    Array.from(document.activeElement?.classList || []).some(i => i.includes('gidbtn') || i.includes('ui-input__input')) &&
    Array.from(document.activeElement?.parentElement?.classList || []).some(i => i.includes('index-element-'))
  ) {
    return Array.from(document.activeElement?.parentElement?.classList || []).find(i => i.includes('index-element-'));
  }
  return Array.from(document.activeElement?.classList || []).find(i => i.includes('index-element-'));
}

export const getClientConfig = () => {
  const storedConfig = localStorage.getItem('AuthClientConfig');
  return storedConfig ? JSON.parse(storedConfig) : config;
}

export const formatClientConfig = () => {
  const config = getClientConfig();
  
  const result: any = {};
  for (const [key, value] of Object.entries(config)) {
    if (key === 'configCacheTtlDays') {
      const days = Number.parseFloat(String(value));
      result.configCacheTtlDays = Number.isFinite(days) && days >= 0 ? days : 7;
      continue;
    }
    if (typeof value === 'string') {
      result[key] = value === 'true' ? true : value === 'false' ? false : value;
    } else {
      result[key] = value;
    }
  }
  return result;
};